import { UsaStates } from 'usa-states'

export const states = new UsaStates().arrayOf('abbreviations')
